import Home from "@/pages/Home.vue";

import { routes as masterDataRoutes } from "@/pages/master-data/routes";
import { routes as adminRoutes } from "@/pages/admin/routes";
import { routes as registrationRoutes } from "@/pages/patient-management/routes";

import { routes as visitRoutes } from "@/pages/visits/routes";
import { routes as insuranceRoutes } from "@/pages/insurance/routes";
import { routes as outpatientsRoutes } from "@/pages/outpatients/routes";
import { routes as admissionRoutes } from "@/pages/admissions/new/routes";
import { routes as inpatientsRoutes } from "@/pages/in-patients/new/routes";
import { routes as billingRoutes } from "@/pages/billing/new/routes";
import { routes as pharmacyRoutes } from "@/pages/pharmacy/new/routes";
import { routes as loanItemsRoutes } from "@/pages/loan-items/routes";
import { routes as radiologyRoutes } from "@/pages/radiology/new/routes";
import { routes as labRoutes } from "@/pages/lab/new/routes";
import { routes as theatreRoutes } from "@/pages/theatre/routes";
import { routes as morgueRoutes } from "@/pages/morgue/new/routes";
import { routes as authRoutes } from "@/pages/auth/routes";
import { routes as reportsRoutes } from "@/pages/reports/routes";
import { routes as inventoryDashBoardRoutes } from "@/pages/inventory-dashboard/routes";
import { routes as supplierModuleRoutes } from "@/pages/suppliers/routes";
import { routes as financeRoutes } from "@/pages/finance/routes";
import { routes as claimsRoutes } from "@/pages/claims/routes";
import { routes as renalRoutes } from "@/pages/renal/routes";
import { routes as medicalFileRoutes } from "@/pages/medical-file/routes";
import { routes as auditRoutes } from "@/pages/audits/routes";
import { routes as profileRoutes } from "@/pages/profile/routes";
import { routes as medfileRoutes } from "@/pages/medfile/routes";
import { routes as appointmentRoutes } from "@/pages/appointments/routes";
import { routes as salesRoutes } from "@/pages/sales/routes"; 
import { routes as dashboardRoutes } from "@/pages/dashboard/routes"; 

export default [
    // {
    //     path: "/",
    //     component: Home,
    //     name: 'home',
    //     meta: {
    //         requiresAuth: true,
    //         permissions: {
    //             PageName: `home`,
    //             PageDescription: "Home Dashboard",
    //         },
    //     }
    // },
    {
        path: "/",
        component: Home,
        name: 'home',
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `home`,
                PageDescription: "Home Dashboard",
            },
        }
    },
    ...masterDataRoutes,
    ...adminRoutes,
    ...registrationRoutes,
    ...visitRoutes,
    ...insuranceRoutes,
    ...outpatientsRoutes,
    ...admissionRoutes,
    ...inpatientsRoutes,
    ...billingRoutes(),
    ...pharmacyRoutes,
    ...loanItemsRoutes(),
    ...radiologyRoutes,
    ...labRoutes,
    ...theatreRoutes,
    ...morgueRoutes,
    ...authRoutes,
    ...reportsRoutes,
    ...inventoryDashBoardRoutes(),
    ...supplierModuleRoutes(),
    ...financeRoutes(),
    ...claimsRoutes(),
    ...renalRoutes(),
    ...medicalFileRoutes(),
    ...auditRoutes(),
    ...profileRoutes(),
    ...medfileRoutes(),
    ...appointmentRoutes(),
    ...salesRoutes(),
    ...dashboardRoutes(),
];
